import { Flow, Vertex } from '@/engine';
import { VertexMetadata } from 'simplex-flow-models';

export interface FlowState {
    currentFlow: Flow | null;
    selectedVertex: Vertex | null;
    selectedVertexInstances: string[];
    vertexMetadata: Record<string, VertexMetadata> | null;
    connectorMetadata: Record<string, any> | null;
    availableConnectors: Record<string, any> | null;
    openApiOperations: Record<string, any> | null;
    openApiOperationFields: Record<string, any> | null;
    openApiServers: Record<string, any> | null;
    openApiServerVariables: Record<string, any> | null;
    report: Record<string, any> | null;
    allAvailableFields: Array<Record<string, string>> | null;
    getConnectorFields: Array<Record<string, string>> | null;
    options: Record<string, any> | null;
    currentFlowType: number | null;
}

export const flowState: FlowState = {
    currentFlow: null,
    selectedVertex: null,
    selectedVertexInstances: [],
    vertexMetadata: null,
    connectorMetadata: null,
    availableConnectors: null,
    openApiOperations: null,
    openApiOperationFields: null,
    openApiServers: null,
    openApiServerVariables: null,
    report: null,
    allAvailableFields: null,
    getConnectorFields: null,
    options: null,
    currentFlowType: null
}
